module.exports = __webpack_public_path__ + "static/media/calendarGraphic.45053680.png";